<template>
  <ComponenteCatalogoAtivo :titulo="'deletado'" />
</template>

<script>
import ComponenteCatalogoAtivo from "../components/ComponenteCatalogoAtivo.vue";

export default {
  components: {
    ComponenteCatalogoAtivo,
  },
  setup() {
    return {};
  },
};
</script>
